// @ts-check
import Debug from 'debug'
const debug = Debug('app:settings:viewUsers')

export class UsersController {
  /* @ngInject */
  constructor ($mdDialog, users, $mdColorPalette, Companies, $mdToast, $scope, user, company, regions, Auth) {
    this.$mdDialog = $mdDialog
    this.users = users
    this.user = user
    this.Companies = Companies
    this.$mdToast = $mdToast
    this.$scope = $scope
    this.company = company
    this.newUserCreate = false
    this.colors = Object.keys($mdColorPalette)
    this.regions = regions
    this.Auth = Auth;
    for (var logo in this.users) {
      this.users[logo].avatarColor = this.colors[Math.floor(Math.random() * this.colors.length)]
    }
  }

  addNewUser () {
    this.newUserCreate = true
  }

  updateClientType (userId, clientType, email, $ev) {
    if (clientType === 'RESEND_INVITE') {
      this.resendInvite(email)
      return
    } 
    const confirm = this.$mdDialog.confirm({
      title: 'Change User Status',
      textContent: 'Are you sure you want to change their access privileges?',
      ariaLabel: 'Confirm Status Change',
      targetEvent: $ev,
      ok: 'Change Status',
      cancel: 'Cancel',
      clickOutsideToClose: true
    })
    this.$mdDialog.show(confirm)
      .then((results) => {
        this.Companies.updateUser({
          userId: userId,
          clientType: clientType
        })
        .then(this.$mdToast.showSimple('Updated User Status'), (err) => {
          if (!err) return
          debug(err)
          this.$mdToast.showSimple('Error Updating Account')
        })
      })
      .catch()
  }

  createNewUser () {
    if (this.createNewUserForm.$invalid) {
      debug('form not valid!')
      this.$mdToast.showSimple('Error With User Info')
      return
    }
    this.Companies.inviteCompanyUser({
      companyId: this.company.internal_id, // MAKE SURE TO USE INTERNAL ID
      firstName: this.newUser.firstName,
      lastName: this.newUser.lastName,
      username: this.newUser.username,
      userType: this.newUser.userType,
      phoneNumber: this.normalizePhoneNumber(), 
      region: this.newUser.region
    })
      .then(() => {
        this.$mdToast.showSimple('Sent Email To User')
        this.newUserCreate = false
        this.$mdDialog.hide()
      })
      .catch((err) => {
        if (!err) return
        debug(err)
        this.$mdToast.showSimple(`Error Sending Account: ${err.data.reason}`)
      })
  }

  resendInvite(username) {
    const confirm = this.$mdDialog.confirm({
      title: 'Resend Invitation?',
      textContent: 'Are you sure you want to resend the invitation email to this user?',
      ariaLabel: 'Confirm Resend',
      ok: 'Yes, Resend',
      cancel: 'Cancel'
    });

    this.$mdDialog.show(confirm).then(() => {
      this.Companies.resendInvite({
         email: username
         })
      .then(() => {
        this.$mdToast.showSimple('Invitation resent successfully.');
      })
      .catch((err) => {
        debug('Resend invite error:', err);
        this.$mdToast.showSimple(`Error resending invitation: ${err.message || 'Unknown error'}`);
      });
    }, () => {
      debug('Resend canceled by user.');
    });
  }


  normalizePhoneNumber() {
    if (this.newUser.phoneNumber) {
      return '1' + this.newUser.phoneNumber;
    } else {
      return '12222222222';
    }
  }
}
